import * as React from 'react'
import './LogPointsConnectorIcon.css'
import IconPanel from '@mulesoft/anypoint-icons/lib/Icon'

export type Props = {
  name: string
  src: string
  testId?: string
}

export type State = {
  imgError: boolean
}

class LogPointsConnectorIcon extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props)

    this.state = {
      imgError: false
    }

    this.onImgError = this.onImgError.bind(this)
  }

  onImgError() {
    this.setState({imgError: true})
  }

  render() {
    const {src, testId} = this.props
    const {imgError} = this.state

    return (
      <div className="log-points-connector-icon" data-test-id={testId}>
        { imgError &&
          <IconPanel size={19} name="connectors-color"/>
        }
        { !imgError &&
          <img src={src} alt={name} onError={this.onImgError}/>
        }
      </div>
    )
  }
}

export default LogPointsConnectorIcon
